import React, { useMemo } from "react";
import clsx from "clsx";

import {
  Context,
  activeLearningStoryBookPath,
} from "../../../../../../teacherStore";
import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import ThemeCard from "../../../../../../organisms/ActiveLearning/ThemeCard";
import ThemeModal from "../../../../../../organisms/ActiveLearning/ThemeModal";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import notFoundImg from "../../../../../../assets/images/ActiveLearning/not_found_theme.jpg";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue | undefined;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const { state } = React.useContext(Context);

  const [themeModal, setThemeModal] = React.useState<{
    isShow: boolean;
    id: number;
  }>({
    isShow: false,
    id: 0,
  });

  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  return (
    <div key={props.issue?.no} className={styles.issue}>
      {themeModal.isShow && (
        <ThemeModal
          videoDomain={process.env.REACT_APP_STUDENT_DLP_URL}
          activeLearningThemes={state.active_learning_themes}
          activeLearningStoryBookPath={activeLearningStoryBookPath}
          handleClose={() => setThemeModal({ ...themeModal, isShow: false })}
          themeId={themeModal.id}
          hideActionButton
        />
      )}
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.header}>
            <span className={styles.no}>
              WORK
              {props.issue?.no && props.issue?.no < 10
                ? `0${props.issue?.no}`
                : props.issue?.no}
            </span>
            <p className={styles.title}>{props.issue?.title}</p>
            <p className={styles.read}>
              「あなたが選んだ分野タグTOP3」と各テーマの詳細を参考に、自分が興味のあるテーマを選択しよう。
              <br />
              また、なぜそのテーマを選んだのかを入力しよう。※動画の再生については先生の指示に従おう。
            </p>
          </div>
          <div className={styles.card}>
            <div className={styles.wrapper}>
              <div className={styles.block}>
                <p className={styles.label}>
                  <IconLive />
                  POINT
                </p>
                <p className={styles.title}>
                  あなたが選んだ
                  <br className={styles.isPc} />
                  分野タグTOP3
                </p>
              </div>
              <div className={styles.block}>
                <p className={styles.text}>
                  選んだ分野タグによって、興味のある分野がランキング形式で表示される。自分の興味のある分野を確認しよう。
                </p>
              </div>
            </div>
          </div>
          <div className={styles.description}>
            <p className={styles.title}>テーマ一覧(あなたへのおすすめ順)</p>
            <ul className={styles.list}>
              <li className={styles.item}>
                これから取り組むテーマの候補がおすすめ順に表示されています。
              </li>
              <li className={styles.item}>
                「詳細を見る」…テーマに関する事例と企業の情報が掲載されています。
              </li>
              <li className={styles.item}>
                「このテーマを選択する」…これから自分が取り組むテーマとして設定できます。
              </li>
            </ul>
          </div>
          <div className={clsx(styles.themeCardList, styles.isPc)}>
            {state.active_learning_themes.map(theme => {
              const no = String(theme.display_order).padStart(2, "0");
              return (
                <ThemeCard
                  key={theme.id}
                  no={no}
                  title={theme.title}
                  desc={theme.desc}
                  imageUrl={
                    theme.enageed_theme_name
                      ? `https://admin.gear.enageed.net${theme.image_url}`
                      : notFoundImg
                  }
                  width={"calc((100% - 16px * 2) / 3)"}
                  handleDetail={() =>
                    setThemeModal({ isShow: true, id: theme.id })
                  }
                />
              );
            })}
          </div>
          <div className={clsx(styles.themeCardList, styles.isSp)}>
            {state.active_learning_themes.map(theme => {
              const no = String(theme.display_order).padStart(2, "0");
              return (
                <ThemeCard
                  key={theme.id}
                  no={no}
                  title={theme.title}
                  desc={theme.desc}
                  imageUrl={
                    theme.enageed_theme_name
                      ? `https://admin.gear.enageed.net${theme.image_url}`
                      : notFoundImg
                  }
                  width={"100%"}
                />
              );
            })}
          </div>
        </div>
      )}
      {question2 && (
        <div className={styles.question}>
          <div className={styles.themEntry}>
            <p className={styles.title}>テーマを選んだ理由を入力しよう。</p>
            <p className={styles.read}>
              自分はどんなことに興味があるのか、なぜそのテーマを選んだのかを入力してみよう。
            </p>
            <div className={styles.textAreaWrapper}>
              <TextArea />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue2Material;
